import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';
import { getHotkeyConfig } from '../../constants/hotkeyConfig';

export default function TooltipButton({
    hotkeyAction,
    showHotkeyLabel = true,
    children,
    className = '',
    variant = 'filled',
    color = 'blue',
    size = 'sm',
    leftSection,
    rightSection,
    loading = false,
    disabled = false,
    fullWidth = false,
    onClick,
    type = 'button',
    ...rest
}) {
    const hotkeyConfig = getHotkeyConfig(hotkeyAction);
    const tooltipLabel = (hotkeyConfig && showHotkeyLabel) ? hotkeyConfig.label : null;

    const colorMap = {
        blue:   'bg-blue-600 hover:bg-blue-700 text-white',
        red:    'bg-red-600 hover:bg-red-700 text-white',
        green:  'bg-green-600 hover:bg-green-700 text-white',
        orange: 'bg-orange-500 hover:bg-orange-600 text-white',
        gray:   'bg-zinc-200 hover:bg-zinc-300 dark:bg-zinc-700 dark:hover:bg-zinc-600 text-zinc-800 dark:text-zinc-100',
    };
    const subtleMap = {
        blue:   'text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20',
        red:    'text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20',
        gray:   'text-zinc-600 hover:bg-zinc-100 dark:hover:bg-zinc-800',
        orange: 'text-orange-500 hover:bg-orange-50 dark:hover:bg-orange-900/20',
    };
    const sizeMap = {
        xs: 'px-3 py-1.5 text-xs gap-1',
        sm: 'px-3 py-1.5 text-sm gap-1.5',
        md: 'px-4 py-2 text-sm gap-2',
        lg: 'px-5 py-2.5 text-base gap-2',
    };

    const colorClass = variant === 'subtle' ? (subtleMap[color] || subtleMap.gray) : (colorMap[color] || colorMap.blue);
    const sizeClass  = sizeMap[size] || sizeMap.sm;

    const btn = (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || loading}
            className={`inline-flex items-center justify-center rounded-md font-medium transition-colors
                disabled:opacity-50 disabled:cursor-not-allowed
                ${colorClass} ${sizeClass} ${fullWidth ? 'w-full' : ''} ${className}`}
            {...rest}
        >
            {loading ? (
                <span className="inline-block w-3.5 h-3.5 border-2 border-current border-t-transparent rounded-full animate-spin" />
            ) : leftSection}
            {children}
            {rightSection}
        </button>
    );

    if (!tooltipLabel) return btn;

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                {btn}
            </TooltipTrigger>
            <TooltipContent side="top">
                {tooltipLabel}
            </TooltipContent>
        </Tooltip>
    );
}
